// @ts-expect-error not migrated TS yet

import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import EmailFolderSelectTreeContainer from 'email-management-lib/refactor/containers/EmailFolderSelectTreeContainer';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import cloneDeep from 'hs-lodash/cloneDeep';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class MoveToFolderMultiModal extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      initialSelection: null,
      selectedFolderId: null,
      selectedFolderName: null
    };
    this.onFolderSelect = (id, folderName) => {
      this.setState({
        selectedFolderId: id,
        selectedFolderName: folderName
      });
    };
    this.onConfirm = e => {
      const folderId = this.state.selectedFolderId && this.state.selectedFolderId > 0 ? this.state.selectedFolderId : null;
      const folderName = this.state.selectedFolderName ? this.state.selectedFolderName : null;
      this.props.onMoveToFolder(e, folderId, folderName);
      if (this.props.isFramework && this.props.crmObject) {
        const updatedCrmObject = cloneDeep(this.props.crmObject);
        const hsFolderIdProperty = updatedCrmObject.properties[PROPERTIES.CONTENT_FOLDER_ID];
        const folderIdString = folderId ? folderId.toString() : '';
        if (hsFolderIdProperty) {
          updatedCrmObject.properties[PROPERTIES.CONTENT_FOLDER_ID].value = folderIdString;
        } else {
          updatedCrmObject.properties[PROPERTIES.CONTENT_FOLDER_ID] = {
            value: folderIdString
          };
        }
        listingLibObserver.update(updatedCrmObject);
      }
    };
  }
  componentDidMount() {
    const {
      toMoveElements
    } = this.props;

    // To show a folder selected,
    //  all selected elements need to be in the same folder
    const noneOrMultipleValues = toMoveElements.length === 0 || toMoveElements.some((val, __i, arr) => val.folderId !== arr[0].folderId);

    // No selection is reflected by null, whereas 0 means root folder
    let initialValue = null;
    if (!noneOrMultipleValues) {
      const folderId = toMoveElements[0].folderId;
      initialValue = folderId !== null ? folderId : 0;
    }
    this.setState({
      initialSelection: initialValue,
      selectedFolderId: initialValue || 0,
      selectedFolderName: ''
    });
  }
  renderConfirmButton() {
    const {
      initialSelection,
      selectedFolderId
    } = this.state;
    const disabled = selectedFolderId === initialSelection;
    if (disabled) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: I18n.text('email-management.table.moveToFolderModal.tooltip'),
        children: /*#__PURE__*/_jsx(Button, {
          "data-test-id": "move-to-folder-modal-confirm-button",
          disabled: disabled,
          onClick: this.onConfirm,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "email-management.table.moveToFolderModal.confirm"
          })
        })
      });
    }
    return /*#__PURE__*/_jsx(Button, {
      "data-test-id": "move-to-folder-modal-confirm-button",
      onClick: this.onConfirm,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "email-management.table.moveToFolderModal.confirm"
      })
    });
  }
  render() {
    const {
      selectedFolderId
    } = this.state;
    return /*#__PURE__*/_jsxs(Modal, {
      "data-test-id": "move-to-folder-modal",
      size: "auto",
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          "data-test-id": "move-to-folder-modal-close-button",
          onClick: this.props.onCancel
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "email-management.table.moveToFolderModal.header"
          })
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx(EmailFolderSelectTreeContainer, {
          onSelect: this.onFolderSelect,
          selectedFolderId: selectedFolderId
        })
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [this.renderConfirmButton(), /*#__PURE__*/_jsx(Button, {
          "data-test-id": "move-to-folder-modal-cancel-button",
          onClick: this.props.onCancel,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "email-management.table.moveToFolderModal.cancel"
          })
        })]
      })]
    });
  }
}
MoveToFolderMultiModal.propTypes = {
  crmObject: PropTypes.object,
  isFramework: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onMoveToFolder: PropTypes.func.isRequired,
  toMoveElements: PropTypes.instanceOf(Array).isRequired
};